const boxShadow = {
  big: '0 20px 40px 0 rgba(0,0,0,0.1);',
  small: '0 2px 4px 0 rgba(0,0,0,0.1);',
};

const colors = {
  cobalt: '#0B1F26',
  navy: '#2d2956',
  royal: '#2b5899',
  blue: '#43c6f4',
  greyDark: '#424243',
  grey: '#989898',
  green: '#3be099',
  offWhite: '#f1f1f1',
  eggshell: '#fdfdfd',
  lightBlue: '#f8fbff',
  white: '#ffffff',
  black: '#000000',
  yellow: '#ffd93b',
  mustard: '#e6c022',
  border: 'rgba(0, 0, 0, 0.1)',
  borderLight: 'rgba(255, 255, 255, 0.4)',
  blueIce: '#f7faff',
};

const sp = {
  xxs: '2px',
  xs: '4px',
  s: '8px',
  m: '16px',
  l: '24px',
  xl: '32px',
  xxl: '48px',
  max: '64px',
};

// Modal's z-index is in Modal.css, it should be 2001
const zIndices = {
  TopBar: 1000,
  NavDrawer: 1002,
};

export default { boxShadow, colors, sp, zIndices };



// WEBPACK FOOTER //
// ./src/styles/theme.js